import { Mail, Waves } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="relative mt-16 overflow-hidden text-deepwater/70">
      {/* Big wordmark — sits like faded text at the bottom of the page */}
      <div className="relative max-w-[100rem] mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-6 flex items-end justify-center">
        <span
          className="block font-serif font-bold text-deepwater/[0.07] leading-none tracking-tight select-none whitespace-nowrap"
          style={{ fontSize: 'clamp(3.5rem, 16vw, 14rem)' }}
          aria-hidden="true"
        >
          shorewood
        </span>
      </div>

      {/* Bottom strip — copyright + single contact */}
      <div className="relative border-t border-mist/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-xs text-slate">
            <Waves className="w-3.5 h-3.5 text-primary/70" aria-hidden="true" />
            <span>
              © {new Date().getFullYear()} The Shorewood Association · A private membership community since 1902
            </span>
          </div>
          <a
            href="mailto:board@shorewoodmi.com"
            className="inline-flex items-center gap-2 text-xs text-slate hover:text-primary transition-colors"
          >
            <Mail className="w-3.5 h-3.5" aria-hidden="true" />
            board@shorewoodmi.com
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
